import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAlertMessage, setPaymentSuccess } from './store/dataslice';

const Failed = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const error = searchParams.get('error');
        if (error) {
            dispatch(setAlertMessage(error));
        }
        navigate("/");
        dispatch(setPaymentSuccess(false));
    }, [navigate]);

    return (
        <Fragment />
    );
}

export default Failed;
